<template>
<div>
    <div id="mygalModal" aria-hidden="true" class="modal fade move-up in intro-modal modal-for-gal" style="display: block;z-index: 9999;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="new-modal">
                    <div class="modal_down bacground_sdo">
                        <!-- Close button -->
                        <a href="#" @click="CloseDialog($event)" class="modal-close-btn">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </a>
                        <div class="intro-modal-body">
                            <!-- Step 1: Ask why they are cancelling -->
                            <div class="trial-details" v-if="el==1">
                                <div class="preview" style="padding-top: 35px !important;display:flex;justify-content: center;">
                                    <span style="font-size: 20px;">Why are you cancelling?</span>
                                </div>
                                <div class="footer-button" style="padding-top: 35px !important;">
                                    <div class="div-block-965 options-container">
                                        <div class="choice-div radio b w-checkbox-med-options" v-for="(option, index) in options_array" :key="index" @click="handleReasonClick(option)">
                                            <label class="radio-button-field w-radio" :id="'radio-' + index">
                                                <span class="radio-button-label w-form-label" style="font-size:16px;" :for="'radio-' + index">{{ option }}</span>
                                            </label>
                                        </div>
                                    </div>
                                    <!-- Custom reason input for "Other" -->
                                    <div v-if="showCustomReason" style="margin-top: 20px;">
                                        <textarea
                                            v-model="customReason"
                                            placeholder="Please tell us more..."
                                            class="custom-reason-input"
                                            rows="3"
                                            maxlength="500"
                                        ></textarea>
                                        <div style="margin-top: 15px; display: flex; justify-content: center;">
                                            <a href="#" @click="submitCustomReason($event)" class="button-44 w-button dash-button" style="width: 150px;color:black">Submit</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Step 2: Would you recommend us -->
                            <div class="trial-details" v-if="el==2">
                                <div class="preview" style="padding-top: 35px !important;display:flex;justify-content: center;">
                                    <span style="font-size: 20px;">Would you recommend us?</span>
                                </div>
                                <div class="footer-button" style="padding-top: 35px !important;">
                                    <div class="div-block-1120">
                                        <a href="#" @click="setRecommend($event, 'yes')" class="button-44 w-button dash-button" style="color:black">Yes</a>
                                        <a href="#" @click="setRecommend($event, 'no')" class="button-44 w-button dash-button">No</a>
                                    </div>
                                </div>
                            </div>

                            <!-- Step 3: AI Processing & Offer Display -->
                            <div class="trial-details" v-if="el==3">
                                <div class="preview" style="padding-top: 35px !important;display:flex;justify-content: center;flex-direction: column;align-items: center;">
                                    <span style="font-size: 20px;" v-if="isWaitingForAI">We're preparing a special offer for you...</span>
                                    <div v-if="isWaitingForAI" style="margin-top: 20px;">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="40px" height="40px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                            <circle cx="50" cy="50" fill="none" stroke="#2E5BFF" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                                            </circle>
                                        </svg>
                                    </div>

                                    <div v-if="!isWaitingForAI && aiOffer" class="ai-offer-container">
                                        <div class="ai-offer-text" v-html="aiOffer"></div>
                                    </div>
                                </div>
                                <div class="footer-button" style="padding-top: 35px !important;" v-if="!isWaitingForAI && aiOffer">
                                    <div class="div-block-1120">
                                        <a href="#" @click="acceptOffer($event)" class="button-44 w-button dash-button" style="color:#fff">
                                            <span v-if="submitted"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="15px" height="15px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                                    <circle cx="50" cy="50" fill="none" stroke="blue" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                                        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                                                    </circle>
                                                </svg></span>
                                            <span v-else>Accept Offer</span>
                                        </a>
                                        <a href="#" @click="proceedToFinalStep($event)" class="button-44 w-button dash-button">Continue Cancellation</a>
                                    </div>
                                </div>
                            </div>

                            <!-- Step 4: Final confirmation -->
                            <div class="trial-details" v-if="el==4">
                                <div class="preview" style="padding-top: 35px !important;display:flex;justify-content: center;">
                                    <span style="font-size: 20px;">Are you sure you want to cancel?</span>
                                </div>
                                <div class="footer-button" style="padding-top: 35px !important;">
                                    <div class="div-block-1120">
                                        <a href="#" @click="cancelSubscription($event)" class="button-44 w-button dash-button" style="color:black">
                                            <span v-if="submitted"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="15px" height="15px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                                    <circle cx="50" cy="50" fill="none" stroke="blue" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                                        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                                                    </circle>
                                                </svg></span>
                                            <span v-else>Yes</span></a>
                                        <a href="#" @click="CloseDialog($event)" class="button-44 w-button dash-button">Close</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ["baseUrl",'subtoCancel'],
    data() {
        return {
            mykey: 1,
            token: null,
            errorReason: '',
            submitted: false,
            reason: '',
            recommend:'',
            el: 1,
            options_array: [
                "It is too expensive",
                "I lost enough weight",
                "The prescription did not work",
                "I do not like the injection method",
                "Too many side effects",
                "Other"
            ],
            isWaitingForAI: false,
            aiOffer: null,
            couponId: null,
            offerMade: false,
            showCustomReason: false,
            customReason: '',
            offerUrl: process.env.VUE_APP_WS_URL
        }
    },
    mounted() {
        // Component mounted
    },
    beforeUnmount() {
        // Cleanup if needed
    },
    methods: {
        handleReasonClick(val) {
            if (val === "Other") {
                // Show custom reason input
                this.showCustomReason = true;
                this.reason = val;
            } else {
                // Directly set reason and proceed
                this.reason = val;
                this.showCustomReason = false;
                this.customReason = '';
                // Move to recommendation step
                this.el++;
            }
        },
        submitCustomReason(event) {
            event.preventDefault();

            if (!this.customReason.trim()) {
                alert('Please enter a reason before submitting');
                return;
            }

            // Use the custom reason
            this.reason = this.customReason.trim();
            this.showCustomReason = false;

            // Move to recommendation step
            this.el++;
        },
        acceptOffer(event) {
            event.preventDefault();

            if (!this.couponId) {
                this.$emit("ShowToastForCancelError", "No coupon available");
                return;
            }

            this.submitted = true;

            // Apply coupon to subscription
            this.$axios.post(`${this.baseUrl}/api/apply-coupon`, {
                subs_id: this.subtoCancel.id,
                coupon_id: this.couponId,
                reason: this.reason,
                recommend: this.recommend
            }).then(response => {
                this.submitted = false;
                if (response.data.status === 'success' || response.data.result === 'ok') {
                    this.$emit("ShowToast", "Coupon applied successfully!");
                    this.$emit("CloseBox");
                    // Refresh parent component subscriptions
                    setTimeout(() => {
                        window.location.reload();
                    }, 1500);
                } else {
                    this.$emit("ShowToastForCancelError", response.data.message || "Failed to apply coupon");
                }
            }).catch(error => {
                this.submitted = false;
                console.error('Error applying coupon:', error);
                this.$emit("ShowToastForCancelError", "Error applying coupon");
            });
        },
        proceedToFinalStep(event) {
            event.preventDefault();
            this.el++;
        },
        setRecommend(event, val) {
            event.preventDefault();
            this.recommend = val;
            this.isWaitingForAI = true;

            // Move to AI offer step
            this.el++;

            // Get retention offer from API
            this.$axios.post(`${this.offerUrl}/api/c/coupon`, {
                user_id: this.$store.getters.user?.id || this.subtoCancel.user_id,
                api_key: process.env.VUE_APP_CHAT_API_KEY || 'default_key',
                cancel_message: this.reason,
                cancel_reason: this.reason
            }).then(response => {
                this.isWaitingForAI = false;

                if (response.data.result === 'ok' && response.data.payload) {
                    const payload = response.data.payload;

                    if (payload.offer_made && payload.message) {
                        this.aiOffer = payload.message;
                        this.couponId = payload.coupon_id;
                        this.offerMade = true;
                    } else {
                        // No offer made, skip to final step
                        this.el++;
                    }
                } else {
                    // Error or no offer, skip to final step
                    this.el++;
                }
            }).catch(error => {
                console.error('Error getting retention offer:', error);
                this.isWaitingForAI = false;
                // On error, skip to final step
                this.el++;
            });
        },
        cancelSubscription(event) {
            event.preventDefault();
            this.submitted = true;
            this.$axios.post(`${this.baseUrl}/api/cancle-subs`,{
                reason: this.reason || "No reason provided",
                recommend: this.recommend || "no",
                subs_id: this.subtoCancel.id
            }).then(response => {
                if (response.data.status == 'error') {
                    this.$emit("ShowToastForCancelError", response.data.message);
                    console.log("error");
                } else {
                    this.$emit("ShowToastForCancel");
                    // Refresh subscriptions
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                }
            }).catch(error => {
                console.log(error)
                this.$emit("ShowToastForCancelError", "Error cancelling subscription");
            });
        },
        CloseDialog(event) {
            event.preventDefault();
            this.$emit("CloseBox");
        },
    },
    created() {

    }
}
</script>

<style scoped>
.modal {
    display: none;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
}

.intro-modal-body {
    justify-content: center;
}

.intro-modal-heading {
    font-size: 18px;
    display: flex;
    justify-content: center;
}

.modal-content {
    background-color: #fefefe;
    border-radius: 10px;
    max-width: 468px;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
    position: relative;
}

.dash-button {
    height: 45px;
}

.options-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
}

.choice-div {
    flex: 1 1 45%;
    min-width: 200px;
    padding: 15px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    background-color: #fff;
}

.choice-div:hover {
    border-color: #2E5BFF;
    background-color: #f0f4ff;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(46, 91, 255, 0.15);
}

.choice-div .radio-button-label {
    cursor: pointer;
    user-select: none;
}

.ai-offer-container {
    width: 100%;
    padding: 20px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
    margin-top: 20px;
}

.ai-offer-text {
    color: #ffffff;
    font-size: 16px;
    line-height: 1.6;
    text-align: center;
}

.ai-offer-text strong {
    font-size: 20px;
    display: block;
    margin-bottom: 10px;
}

.button-44 {
    background-color: #00cc8d;
    border: 1px solid #00cc8d;
}

.button-44:hover {
    background-color: #00cc8d;
    border-color: #00cc8d;
}

.button-44 {
    background-color: #fff;
    color: #333;
    border: 1px solid #ddd;
}

.button-44:hover {
    background-color: #f5f5f5;
}

.custom-reason-input {
    width: 100%;
    padding: 12px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    font-size: 14px;
    font-family: inherit;
    resize: vertical;
    transition: border-color 0.3s ease;
}

.custom-reason-input:focus {
    outline: none;
    border-color: #2E5BFF;
    box-shadow: 0 0 0 3px rgba(46, 91, 255, 0.1);
}

.custom-reason-input::placeholder {
    color: #999;
}

.modal-close-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: #f5f5f5;
    color: #666;
    transition: all 0.3s ease;
    z-index: 10;
    text-decoration: none;
}

.modal-close-btn:hover {
    background-color: #ff4c46;
    color: #fff;
    transform: rotate(90deg);
}

.modal-close-btn svg {
    width: 18px;
    height: 18px;
}
</style>
